// YYYY-MM-DD for the admin's *local* calendar day. toISOString() gives the UTC
// day instead, which in Dhaka (UTC+6) is still yesterday until 6 AM — so a
// default "up to today" range silently dropped every order placed after
// midnight.
export const toLocalDateString = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};
